import { copyToClipboard } from '@/utils/clipboard';
import './validation';
import { Auth0Plugin } from '@/auth';

import { createApp } from 'vue';
import 'bootstrap';
import { isNavigationFailure } from 'vue-router';
import './assets/scss/index.scss';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
// FontAwesome Vue 3 API
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPencilAlt,
  faChartBar,
  faChevronRight,
  faDesktop,
  faFilePdf,
  faUserAlt,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faUserFriends,
  faChartPie,
  faChartLine,
  faClipboardList,
  faUserCircle,
  faSignOutAlt,
  faStar,
  faDownload,
  faLink,
  faCheckCircle,
  faTag,
  faHeadset,
} from '@fortawesome/free-solid-svg-icons';
import {
  faTrash,
  faTrashAlt,
  faBriefcase,
  faTimes,
  faFileAlt,
  faCheckCircle as farCheckCircle,
  faExclamationCircle,
  faInfoCircle,
  faCloudUploadAlt,
  faMegaphone,
  faEllipsisH,
  faSearch,
  faEnvelope,
  faPhone,
  faCommentAltSmile,
  faPlus,
  faMinus,
  faVolume,
  faEyeSlash,
  faTasks,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Bugsnag from '@/service/bugsnag';
import installGtag from '@/plugins/gtag';
import installIntercom from '@/plugins/intercom';
library.add(
  faTrash,
  faTrashAlt,
  faPencilAlt,
  faChartBar,
  faChevronRight,
  faDesktop,
  faFilePdf,
  faUserAlt,
  faChevronDown,
  faChevronUp,
  faFileAlt,
  faChevronLeft,
  faUserFriends,
  faChartPie,
  faChartLine,
  faClipboardList,
  faUserCircle,
  faSignOutAlt,
  faTimes,
  faBriefcase,
  faStar,
  faDownload,
  faCloudUploadAlt,
  faCheckCircle,
  faExclamationCircle,
  faInfoCircle,
  farCheckCircle,
  faMegaphone,
  faEllipsisH,
  faSearch,
  faTag,
  faEnvelope,
  faPhone,
  faCommentAltSmile,
  faPlus,
  faMinus,
  faHeadset,
  faVolume,
  faEyeSlash,
  faLink,
  faTasks
);
import VueSecureHTML from 'vue-html-secure';

const app = createApp(App);
app.use(VueSecureHTML);
app.use(router);
app.use(store);
app.use(i18n);
app.use(Auth0Plugin, {
  domain: window.envVars.VUE_APP_AUTH0_DOMAIN,
  clientId: window.envVars.VUE_APP_AUTH0_CLIENT_ID,
  audience: window.envVars.VUE_APP_AUTH0_AUDIENCE,
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
  onRedirectCallback: appState => {
    router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
  },
});

// Register FontAwesome
app.component('font-awesome-icon', FontAwesomeIcon);

const bugsnagVue = Bugsnag.getPlugin('vue');
app.use(bugsnagVue);

const analyticsId = window.envVars?.VUE_APP_GOOGLE_ANALYTICS_ID || null;
installGtag(app, router, analyticsId);

const intercomAppId = window.envVars?.VUE_APP_INTERCOM_APP_ID || null;
if (intercomAppId) {
  installIntercom(app, intercomAppId);
}

app.config.globalProperties.$copyToClipboard = copyToClipboard;

app.config.globalProperties.$environmentVariables = window.envVars || {};

// Suppress expected Vue Router NavigationFailure rejections from being treated as unhandled errors
window.addEventListener('unhandledrejection', event => {
  if (isNavigationFailure(event.reason)) {
    event.preventDefault();
  }
});

app.mount('#app');
